import * as Reakit from 'reakit/Combobox'

import { COMPONENT_ANIMATION_DURATION } from '../constants'

export function useComboBoxState(options?: Reakit.unstable_ComboboxInitialState) {
  return Reakit.unstable_useComboboxState({
    ...options,
    animated: COMPONENT_ANIMATION_DURATION,
    modal: false,
    inline: true,
    unstable_offset: [0, 5],
  })
}
